import type {CSSProperties} from 'react'
import type {Asset} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'

import {AssetTypeEnum} from '../types'
import type {AssetType} from '../types'

export function getAssetImageStyle(asset?: Asset): CSSProperties | undefined {
  const imageDimensions = asset?.fields.file.details?.image

  if (!imageDimensions?.width || !imageDimensions?.height) return undefined

  return {'--brand-image-aspectRatio': `${imageDimensions.width} / ${imageDimensions.height}`}
}

export function hasExternalVideo(assetType: AssetType | undefined, videoSource: string | undefined): boolean {
  return assetType === AssetTypeEnum.enum['External Video'] && Boolean(videoSource)
}
